export default "__VITE_ASSET__no5hx0cC__"